import Fullscreen from '@iez/features/fullscreen/'

export default () => {
  Fullscreen()
}
